import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isTrellisCompatibleComponent"],
  _excluded2 = ["isTrellisCompatibleComponent"];
import styled from 'styled-components';
import HorizontalEdgeToolbar, { TrellisHorizontalEdgeToolbar } from './HorizontalEdgeToolbar';
import { EDGE_TOOLBAR_HEIGHT } from './constants';
import { withNonTrellisComponent, withTrellisComponent } from '../withTrellisCompatibleHoc';
import { filterProps } from 'foundations-components/utils/filterProps';

// Adjustment to "pull up" the rotated toolbar to the expected top left position
import { jsx as _jsx } from "react/jsx-runtime";
const TOP_ADJUSTMENT = -1 * EDGE_TOOLBAR_HEIGHT;
const VerticalEdgeToolbar = props => {
  if (props.isTrellisCompatibleComponent) {
    const rest = _objectWithoutPropertiesLoose(props, _excluded);
    let {
      tokenProps: {
        insetBlockStart
      }
    } = filterProps(rest);

    // If a custom top position is passed, make sure to combine it with the top adjustment, otherwise
    // it will be blown away by the overriding style
    insetBlockStart = insetBlockStart ? `calc(${insetBlockStart} + ${TOP_ADJUSTMENT}px)` : `${TOP_ADJUSTMENT}px`;
    return /*#__PURE__*/_jsx(TrellisHorizontalEdgeToolbar, Object.assign({
      dropdownPlacement: "right",
      rotateHandleIcon: "90deg",
      rotateActionIcons: "90deg",
      transform: "rotate(270deg) translate(-100%, 0)",
      transformOrigin: "left bottom 0",
      position: "relative"
    }, rest, {
      insetBlockStart: insetBlockStart
    }));
  }
  const rest = _objectWithoutPropertiesLoose(props, _excluded2);
  let style = props.style;

  // If a custom top position is passed, make sure to combine it with the top adjustment, otherwise
  // it will be blown away by the overriding style
  if (style && style.top != null) {
    style = Object.assign({}, style, {
      // Pre-existing bug, will come back to this when we're sure we still need
      // this computation in the trellis version
      // @ts-expect-error Operator '+=' cannot be applied to types 'Top<string | number>' and 'number'.ts(2365)
      top: style.top += TOP_ADJUSTMENT
    });
  }
  return /*#__PURE__*/_jsx(HorizontalEdgeToolbar, Object.assign({
    dropdownPlacement: "right"
  }, rest, {
    style: style
  }));
};
export const LegacyVerticalEdgeToolbar = styled(withNonTrellisComponent(VerticalEdgeToolbar)).withConfig({
  displayName: "VerticalEdgeToolbar__LegacyVerticalEdgeToolbar",
  componentId: "sc-1ectoho-0"
})([".hs-private.hs-private.hs-private &{transform:rotate(270deg) translate(-100%,0);transform-origin:left bottom 0;position:relative;top:", "px;}"], TOP_ADJUSTMENT);
export const TrellisVerticalEdgeToolbar = withTrellisComponent(VerticalEdgeToolbar);
export default LegacyVerticalEdgeToolbar;